import $ from 'jquery';

export default function () {
  $('.mobile-nav-plusicon').click(function (e) {
    e.preventDefault();
    $(this).parent().next('ul').slideToggle(100);
    $(this).find('.minus2').toggleClass('animate');
  });

  $('.eingabefeld').click(function (event) {
    if ($(this).data('closer') === true) {
      $('.picker__button--close').trigger('click');
      $(this).data('closer', false);
    } else {
      $(this).data('closer', true);
    }
  });

  $('#booking-button').click(function (e) {
    e.preventDefault();
    $('#booking-filter').toggleClass('show');
    $('.booking-revealer-btn').hide();
    $('.booking-revealer').show();
  });

  $('.booking-close-btn').click(function (e) {
    e.preventDefault();
    $('#booking-filter').removeClass('show');
  });

  $('#more-entries-btn').click(function (e) {
    e.preventDefault();
    $('#entries').children().each(function () {
      if ($(this).data('hide') === true) { $(this).toggle(); }
    });
    $(this).html($(this).html().indexOf($(this).data('open')) !== -1 ? $(this).data('close') : $(this).data('open'));
  });

  $('#ls_btn').click(function () {
    $(this).toggleClass('turn');
  });

  let dateDiffInDays = function (date1, date2) {
    date1 = new Date(date1.split('.').reverse().join('.'));
    date2 = new Date(date2.split('.').reverse().join('.'));

    return Math.floor((Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) - Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())) / (1000 * 60 * 60 * 24));
  };

  var unterkunft;
  $('.button--booking_filter').click(function () {
    var bookingFilter = $(this).closest('.booking_filter');
    var locale = bookingFilter.find('input[name=locale]').val();
    var segment1 = bookingFilter.find('input[name=segment1]').val();
    if (segment1 !== 'winter' && segment1 !== 'sommer') {
      segment1 = 'winter';
    }

    if (bookingFilter.find('select[name=unterkunft]').val() !== 'unterkunft') {
      unterkunft = bookingFilter.find('select[name=unterkunft]').val();
      localStorage.setItem('unterkunft', unterkunft);
    }
    var einreise = bookingFilter.find('input[name=einreise]').val();
    var ausreise = bookingFilter.find('input[name=ausreise]').val();
    var reisedauer = dateDiffInDays(einreise, ausreise);

    var personen = bookingFilter.find('select[name=erwachsene]').val();
    var segment2 = '';

    switch (locale) {
      case 'en':
        segment2 = 'sleeping';
        break;
      case 'it':
        segment2 = 'sonno';
        break;
      default:
        segment2 = 'schlafen';
    }
    if (unterkunft === 'ferienwohnung') {
      window.open('http://115140000000.holidaybooking.ch/?event=search.search&ort=1042893' + '&personen=' + personen + '&datvon=' + einreise + '&reisedauer=' + reisedauer);
    } else {
      if (locale !== 'de') {
        if (window.location.href.match(/(schlafen|sleeping|sonno)/)) {
          $('#' + unterkunft).trigger('click');
          $('#booking-filter').removeClass('show');
        } else {
          window.location.href = '/' + locale + '/' + segment1 + '/' + segment2 + '/#' + unterkunft;
        }
      } else {
        if (window.location.href.match(/(schlafen|sleeping|sonno)/)) {
          $('#' + unterkunft).trigger('click');
          $('.booking_filter').removeClass('show');
          $('.spinner > div').css('display', 'none');
        } else {
          window.location.href = '/' + segment1 + '/' + segment2 + '/#' + unterkunft;
        }
      }
    }
  });

  if (localStorage.getItem('unterkunft') || window.location.search.split('=')[1]) {
    unterkunft = localStorage.getItem('unterkunft') ? localStorage.getItem('unterkunft') : window.location.search.split('=')[1];
    var tag = $('#' + unterkunft);
    $('.spinner > div').css('display', 'none');
    if (localStorage.getItem('unterkunft')) {
      localStorage.removeItem('unterkunft');
    }
    tag.trigger('click');
  }

  /// sub-navigation--mobile

  $('.kontakt-btn-mobile').click(function (e) {
    e.preventDefault();
    $(this).parent().parent().find('.kontakt-mobile').slideToggle(100);
  });

  $('.kontakt-close-btn').click(function (e) {
    e.preventDefault();
    $(this).parent().slideToggle(100);
  });

  $('.weather-widget-btn-mobile').click(function (e) {
    e.preventDefault();
    $(this).parent().parent().find('.weather-widget-mobile').slideToggle(100);
  });

  $('.weather-widget-close-btn').click(function (e) {
    e.preventDefault();
    $(this).parent().slideToggle(100);
  });

  /// Kontakt-Btn Desktop

  $('.kontakt-btn-desktop').on('click', function (e) {
    var href = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(href).offset().top - $('.header-spacer').height() - 25,
    }, 225);
    e.preventDefault();
  });

  $('.taxclick').click(function (e) {
    e.preventDefault();
    localStorage.setItem('filter', $(this).data('filter'));
    var url = $(this).closest('ul').prev().attr('href');
    $(this).attr('href', url);
    window.location.href = url;
  });

  if (localStorage.getItem('filter')) {
    var taxfilter = localStorage.getItem('filter');
    localStorage.removeItem('filter');
    tag = $('#' + taxfilter);

    tag.trigger('click');
  }

  $('.get_down').on('click', function (e) {
    var href = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(href).offset().top - $('.header-spacer').height() - 25,
    }, 225);
    e.preventDefault();
  });
}
